import { buildHeadingSegments } from "../newThread/NewThreadLanding.logic";
import { DraftHeroHeadline } from "./DraftHeroHeadline";

export function TimelineEmptyState({
  projectName,
  timelineInset,
}: {
  readonly projectName: string | null | undefined;
  readonly timelineInset: number;
}) {
  const name = projectName?.trim() ?? "";
  return (
    <div
      className="flex h-full items-center justify-center px-6"
      style={{ paddingBottom: timelineInset }}
    >
      {name.length > 0 ? (
        <DraftHeroHeadline headingSegments={buildHeadingSegments(name)} className="max-w-2xl" />
      ) : (
        <p className="text-sm text-muted-foreground/30">
          Send a message to start the conversation.
        </p>
      )}
    </div>
  );
}
